module.exports = __webpack_public_path__ + "img/h5_P12.a00311e0.jpg";